/* noted. — Skipstone portal and allocation builder.

   Owns every Skipstone-specific behaviour on /tools/bundle-subscriptions.
   Kept out of assets/awtomic-theme-custom.js so an Awtomic update to that file
   cannot silently take our rules with it.

   WHY THE OLD GUARD FAILED. It scoped its disabling CSS to body.awt-bab-open
   while only ever setting awt-cp, it scraped the total with the FIRST
   'div > span.bundle-text--emphasis' in the document rather than the footer's,
   it only armed on a click, and its observers self-destructed after 5000ms.
   A member could save a $255 Cave Collector allocation.

   TWO SAFETY RULES, 2026-08-21, after this file hung the portal on a spinner:

   1. THE TEXT WALKER SKIPS SCRIPT AND STYLE. It did not, and Awtomic ships
      inline script on this page. Rewriting a string inside their own source is
      how a copy swap turns into a dead app.

   2. NOTHING HERE MAY BLOCK THE PAGE. Every entry point is wrapped. A portal
      that loads with our styling missing is a bad afternoon; a portal that
      does not load is a member who cannot fix their card before billing. */
(function () {
  "use strict";

  /* THE MINIMUMS LIVE IN assets/skipstone-tiers.js, NOT HERE. Config, not
     code. The literal below is a fallback for one case only, that file failing
     to load, and is deliberately the strictest reading of every figure so a
     missing config over-blocks rather than under-blocks. */
  var TIERS = window.SKIPSTONE_TIERS || {
    "54150225953132": { name: "Cave Collector", bottles: 0, spend: 550 },
    "54150226248044": { name: "Wine Vault", bottles: 0, spend: 1500 },
    "54150226444652": { name: "Cellar Master", bottles: 0, spend: 3000 }
  };

  if (window.location.pathname.indexOf("/tools/bundle-subscriptions") === -1) return;

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, TEXTAREA: 1 };

  function money(n) {
    return "$" + Math.round(n).toLocaleString("en-US");
  }

  var tierId = null;
  function findTier() {
    var el = document.querySelector('.bundle-container[class*="pv_"]');
    if (el) {
      var m = el.className.match(/pv_(\d+)/);
      if (m && TIERS[m[1]]) return m[1];
    }
    var row = document.querySelector('[class*="ProductVariant/"]');
    if (row && typeof row.className === "string") {
      var r = row.className.match(/ProductVariant\/(\d+)/);
      if (r && TIERS[r[1]]) return r[1];
    }
    return tierId;
  }

  /* THE LIST PAGE HAS NO TIER IN THE URL.
     /tools/bundle-subscriptions with no subscriptionId shows every membership
     at once, so there is no single tier to read from the page. Naming the
     minimum from the global tier produced "require a minimum purchase." with
     no figure at all. The tier is therefore read from the words beside the
     sentence: walk a few levels up from the text node until a tier name
     appears. Six levels is enough to reach the card and not so far that it
     reaches a sibling membership. */
  function tierNear(node) {
    var el = node && node.parentNode;
    for (var i = 0; i < 6 && el; i++) {
      var t = (el.textContent || "").toLowerCase();
      for (var id in TIERS) {
        if (TIERS.hasOwnProperty(id) && t.indexOf(TIERS[id].name.toLowerCase()) !== -1) {
          return TIERS[id];
        }
      }
      el = el.parentElement;
    }
    return tierId ? TIERS[tierId] : null;
  }

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll(".bundle-product-card"));
  }
  function qtySpan(card) {
    return card.querySelector(".bundle-product-card__quantity-button-container > span");
  }
  function bottleCount() {
    return cards().reduce(function (n, c) {
      var s = qtySpan(c);
      var v = s ? parseInt(s.textContent, 10) : 0;
      return n + (isNaN(v) ? 0 : v);
    }, 0);
  }

  function markMagnums() {
    cards().forEach(function (c) {
      if (/1\.5\s*l\b/i.test(c.textContent)) c.classList.add("skipstone-magnum");
    });
  }

  function builderFooter() {
    return document.querySelector(".bundleapp-modal__container--complete-screen footer") ||
           document.querySelector(".bundle-container footer");
  }

  /* Awtomic prints the list total struck through beside the net one. Their
     class names are hashed, so computed style is the reliable test: anything
     in the footer carrying line-through is the list price, and it is hidden.
     visibility, not display, so the total does not jump when a discount
     appears or disappears. */
  function hideStruckPrices() {
    var f = builderFooter();
    if (!f) return;
    Array.prototype.forEach.call(f.querySelectorAll("*"), function (el) {
      if (el.classList.contains("skipstone-struck-hidden")) return;
      if (!/\$/.test(el.textContent)) return;
      if (el.children.length) return;
      var d = window.getComputedStyle(el).textDecorationLine || "";
      if (d.indexOf("line-through") === -1) return;
      el.classList.add("skipstone-struck-hidden");
      el.style.visibility = "hidden";
      el.style.position = "absolute";
      el.style.pointerEvents = "none";
    });
  }

  function netTotal() {
    var f = builderFooter();
    if (!f) return null;
    var hits = f.textContent.replace(/,/g, "").match(/\$\s*\d+(\.\d+)?/g);
    if (!hits || !hits.length) return null;
    return parseFloat(hits[hits.length - 1].replace(/[^0-9.]/g, ""));
  }

  function primaryButton() {
    var f = builderFooter();
    if (!f) return null;
    var b = f.querySelectorAll("button");
    return b.length ? b[b.length - 1] : null;
  }

  function sentenceFor(tier) {
    return tier
      ? "Customized allocations require a minimum purchase of " + money(tier.spend) + "."
      : "Customized allocations require a minimum purchase.";
  }

  var noteEl = null;
  function note(text, blocked) {
    var f = builderFooter();
    if (!f) return;
    if (!noteEl || !f.contains(noteEl)) {
      noteEl = document.createElement("div");
      noteEl.className = "skipstone-minimum-note";
      f.insertBefore(noteEl, f.firstChild);
    }
    if (noteEl.textContent !== text) noteEl.textContent = text;
    noteEl.setAttribute("data-blocked", blocked ? "yes" : "no");
  }

  function block(btn, on) {
    if (on) {
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("skipstone-blocked");
      document.body.classList.add("skipstone-minimum-not-met");
    } else {
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-disabled");
      btn.classList.remove("skipstone-blocked");
      document.body.classList.remove("skipstone-minimum-not-met");
    }
  }

  function evaluate() {
    if (!builderFooter()) return;
    var id = findTier();
    if (id) tierId = id;
    var tier = tierId ? TIERS[tierId] : null;
    var btn = primaryButton();
    if (!btn) return;

    /* Fail closed. If the builder is open and we cannot identify the tier or
       read a total, block rather than let an unchecked allocation save. */
    if (!tier) {
      block(btn, true);
      note("We could not read your membership tier. Please reload the page.", true);
      return;
    }
    var total = netTotal();
    if (total === null) {
      block(btn, true);
      note("We could not read your allocation total. Please reload the page.", true);
      return;
    }

    var shortBottles = tier.bottles - bottleCount();
    var shortSpend = tier.spend - total;
    var word = shortBottles === 1 ? "bottle" : "bottles";

    if (shortBottles > 0 && shortSpend > 0) {
      block(btn, true);
      note("Add " + shortBottles + " more " + word + " and " + money(shortSpend) + " to complete your allocation.", true);
    } else if (shortBottles > 0) {
      block(btn, true);
      note("Add " + shortBottles + " more " + word + " to complete your allocation.", true);
    } else if (shortSpend > 0) {
      block(btn, true);
      note("Add " + money(shortSpend) + " to complete your allocation.", true);
    } else {
      block(btn, false);
      note(sentenceFor(tier), false);
    }
  }

  /* TYPED QUANTITY. The input never writes Awtomic's state. It clicks their
     own plus and minus the right number of times, so their handlers remain the
     only thing that changes a quantity. */
  function stepper(card) {
    var b = card.querySelectorAll(".bundle-product-card__quantity-button-container--button");
    return { minus: b[0], plus: b[b.length - 1] };
  }

  function addTypedInput(card) {
    if (card.querySelector(".skipstone-qty-input")) return;
    var span = qtySpan(card);
    if (!span) return;

    var input = document.createElement("input");
    input.type = "text";
    input.inputMode = "numeric";
    input.className = "skipstone-qty-input";
    input.setAttribute("aria-label", "Quantity");
    input.value = span.textContent.trim();
    span.parentNode.insertBefore(input, span);
    span.classList.add("skipstone-qty-mirror");

    var sync = function () {
      if (document.activeElement !== input) input.value = span.textContent.trim();
    };
    new MutationObserver(sync).observe(span, { childList: true, characterData: true, subtree: true });

    var apply = function () {
      var want = parseInt(input.value, 10);
      if (isNaN(want) || want < 0) { sync(); return; }
      var have = parseInt(span.textContent, 10) || 0;
      var s = stepper(card);
      var btn = want > have ? s.plus : s.minus;
      var n = Math.abs(want - have);
      if (!btn || !n) return;
      var i = 0;
      (function tick() {
        if (i++ >= n) { evaluate(); return; }
        btn.click();
        setTimeout(tick, 40);
      })();
    };
    input.addEventListener("change", apply);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); apply(); }
    });
    input.addEventListener("blur", sync);
  }

  function addClearAll() {
    var f = builderFooter();
    if (!f || f.querySelector(".skipstone-clear-all")) return;
    var b = document.createElement("button");
    b.type = "button";
    b.className = "skipstone-clear-all";
    b.textContent = "Clear all selections";
    b.addEventListener("click", function () {
      var delay = 0;
      cards().forEach(function (c) {
        var span = qtySpan(c);
        var have = span ? parseInt(span.textContent, 10) || 0 : 0;
        var s = stepper(c);
        for (var i = 0; i < have; i++) {
          setTimeout(function () { if (s.minus) s.minus.click(); }, (delay++) * 40);
        }
      });
      setTimeout(evaluate, delay * 40 + 200);
    });
    f.insertBefore(b, f.firstChild);
  }

  /* Copy Awtomic does not expose through a locale key. Each replacement is
     given the text node so it can name the right tier on a page showing more
     than one. */
  var SWAPS = [
    [/\b\d+\s+items?\s+min\.?/i, function (node) {
      var t = tierNear(node);
      return t ? "Minimum purchase " + money(t.spend) : "Minimum purchase applies";
    }],
    [/Select at least \d+ [Bb]ottles?\s*\(\$[\d,]+ min spend\)/i, function (node) {
      return sentenceFor(tierNear(node));
    }],
    [/Minimum price of \$[\d,.]+ is required for this club\./i, function (node) {
      return sentenceFor(tierNear(node));
    }]
  ];

  function rewriteCopy() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains("skipstone-minimum-note")) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = w.nextNode())) {
      for (var i = 0; i < SWAPS.length; i++) {
        if (SWAPS[i][0].test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(SWAPS[i][0], SWAPS[i][1](n));
          break;
        }
      }
    }
  }

  function markHeadings() {
    var sel = ".bundle-section__title, .bundle-details-table-title";
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (h) {
      h.classList.add("skipstone-flourished");
    });
  }

  function pass() {
    tierId = findTier() || tierId;
    markHeadings();
    markMagnums();
    rewriteCopy();
    cards().forEach(addTypedInput);
    addClearAll();
    hideStruckPrices();
    evaluate();
  }

  function safePass() {
    try { pass(); } catch (e) { console.warn("[skipstone-portal]", e); }
  }

  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; safePass(); });
  });

  function start() {
    try {
      safePass();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      document.body.addEventListener("click", function () {
        setTimeout(function () {
          try { evaluate(); hideStruckPrices(); } catch (e) { console.warn("[skipstone-portal]", e); }
        }, 120);
      }, true);
    } catch (e) {
      console.warn("[skipstone-portal] disabled", e);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
